var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 7.08516L18.375 8.8125V5.25C18.375 4.42266 17.7023 3.75 16.875 3.75H3C2.17266 3.75 1.5 4.42266 1.5 5.25V18.75C1.5 19.5773 2.17266 20.25 3 20.25H16.875C17.7023 20.25 18.375 19.5773 18.375 18.75V15.1875L21.375 16.9148C21.8742 17.2031 22.5 16.8422 22.5 16.268V7.73438C22.5 7.15781 21.8742 6.79687 21.375 7.08516ZM16.6875 18.5625H3.1875V5.4375H16.6875V18.5625ZM20.8125 14.6484L18.375 13.2469V10.7555L20.8125 9.35156V14.6484ZM4.875 8.4375H7.5C7.60313 8.4375 7.6875 8.35313 7.6875 8.25V7.125C7.6875 7.02187 7.60313 6.9375 7.5 6.9375H4.875C4.77187 6.9375 4.6875 7.02187 4.6875 7.125V8.25C4.6875 8.35313 4.77187 8.4375 4.875 8.4375Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.707107,
    y1: 2.29289,
    x2: 20.5061,
    y2: 22.0919,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraOff);
export default __webpack_public_path__ + "static/media/camera-off.8d2e47361a8099ade692d0daa74f8cd7.svg";
export { ForwardRef as ReactComponent };